import i18n from "src/app/shared/localization/i18n"
export const DELETED_MESSAGE_MESSAGE: string = i18n.t('chat.messageDeleted');
export const CANNOT_EDIT_MESSAGE_WITH_FILE = i18n.t('chat.messageFileNoEdit');